import { useEffect } from "react";
import { useFormik } from "formik";
import { toastr } from "react-redux-toastr";
import { SubHeader } from "layout/SubHeader";
import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@material-ui/core/Dialog";
import { useLocation } from "react-router-dom";
import React, { useCallback, useState } from "react";
import NewCharge from "../NewFinance/NewCharge";
import UserContext from "../NewFinance/NewChargeContext";
// component
import MyModal from "components/MyModal";

import Button from "components/button/Button";
import DonationService from "Lib/API/Donation";
import FinanceService from "Lib/API/Finance";
import { downloadBlobFile } from "utils/functions";
import RightDrawer from "components/drawer/index";
import SearchDownShift from "components/downmshift/DownShift";
import { ReactComponent as FilterIcon } from "assets/icons/filter-icon.svg";
import { ReactComponent as FilterActive } from "assets/icons/filter-active-icon.svg";
// direct import
import "../NewFinance/index.scss";
import { FilterWrapper } from "./Theme";
import { getIdsSelected } from "./helper";
import TributeLetterTable from "./TributeLetterTable";
import FinanceDrawer from "../NewFinance/Drawer/index";
import NotAuthorized from "../../components/NotAuthorized";
import DonationFilter from "./DonationFilter/DonationFilter";
import BulkTaggingModal from "./BulkTaggingModal/BulkTaggingModal";
import ViewDocumentModal from "../NewFinance/Documents/ViewDocumentModal/index";
import ShareDocumentsModal from "../NewFinance/Documents/ShareDocumentsModal/index";
import { formatDate } from "helper/dateFormat";
import Spinner from "components/spinner";

const Donation = () => {
  const { search } = useLocation();
  const { getAccessTokenSilently } = useAuth0();
  const searchParams = new URLSearchParams(search);
  const accountIdParam = searchParams.get("accountId");

  const initialFilters = {
    sort: {},
    filter: accountIdParam ? { accountId: accountIdParam } : {},
  };

  const [page, setPage] = useState(0);
  const [check, setCheck] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [viewClick, setViewClick] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [openFilters, setOpenFilters] = useState(false);
  const [editTribute, setEditTribute] = useState(false);
  const [applyFilter, setApplyFilter] = useState(false);
  const [donationModal, setDonationModal] = useState(null);
  const [sortData, setSortData] = useState(initialFilters);
  const [filterApplied, setFilterApplied] = useState(false);
  const [editTributeData, setEditTributeData] = useState({});
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [isDonationActive, setIsDonationActive] = useState(true);
  const [openDocumentModal, setOpenDocumentModal] = useState(false);
  const [viewDocumentContent, setViewDocumentContent] = useState(null);
  const [openBulkTaggingModal, setOpenBulkTaggingModal] = useState(false);
  const [addBulkTaggingLoading, setAddBulkTaggingLoading] = useState(false);
  const [viewDocumentId, setViewDocumentId] = useState(null);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [documentRow, setDocumentRow] = useState(null);
  const [openNewCharge, setOpenNewCharge] = useState(false);
  const [newChargeData, setNewChargeData] = useState(null);
  const [hfinish, setHFinish] = useState(false);

  useEffect(() => {
    const onPayNow = ({ detail }) => {
      setNewChargeData({ ...detail, type: "pay-now" });
      setOpenNewCharge(true);
    };
    document.addEventListener("pay-now", onPayNow);
    return () => document.removeEventListener("pay-now", onPayNow);
  }, []);

  const formik = useFormik({
    isInitialValid: false,
    enableReinitialize: false,
    initialValues: {
      assign_email: editTributeData?.tribute_info?.assign_tribute,
      tribute_type:
        editTributeData?.tribute_info?.type ??
        editTributeData?.tribute_info?.type?.name,
      donor_name: editTributeData?.tribute_info?.name,
      note: editTributeData?.tribute_info?.message,
      showAcknowledgement:
        editTributeData?.tribute_info?.acknowledgment || false,
      acknowledgements: editTributeData?.tribute_info?.recipients?.length
        ? editTributeData?.tribute_info?.recipients?.map((item) => ({
            recipient_name: item?.recipient_name,
            email: item?.email,
            tribute_address: item?.tribute_address,
          }))
        : [
            {
              recipient_name: "",
              email: "",
              tribute_address: "",
            },
          ],
      ledgers: [],
      filterValues: {
        dateRange: null,
        status: "",
        type: "",
        amountRange: {
          min: "",
          max: "",
        },
      },
      tags: [],
    },
  });

  useEffect(() => {
    if (editTributeData?.tribute_info?.type) {
      formik.setFieldValue(
        "assign_email",
        editTributeData?.tribute_info?.assign_tribute
      );
      formik.setFieldValue("tribute_type", editTributeData?.tribute_info?.type);
      formik.setFieldValue("donor_name", editTributeData?.tribute_info?.name);
      formik.setFieldValue("note", editTributeData?.tribute_info?.message);
      formik.setFieldValue(
        "showAcknowledgement",
        editTributeData?.tribute_info?.acknowledgment || false
      );
      formik.setFieldValue(
        "acknowledgements",
        editTributeData?.tribute_info?.recipients?.length
          ? editTributeData?.tribute_info?.recipients?.map((item) => ({
              recipient_name: item?.recipient_name,
              email: item?.email,
              tribute_address: item?.tribute_address,
            }))
          : [
              {
                recipient_name: "",
                email: "",
                tribute_address: "",
              },
            ]
      );
    }
  }, [editTributeData]);
  const sortCharged = (e) => {
    setSortData((prev) => ({
      ...prev,
      sort: {
        [e]: prev.sort[e] === 1 ? -1 : 1,
      },
    }));
  };

  let orgInfo = localStorage?.getItem("authorizedModules")
    ? JSON.parse(localStorage?.getItem("authorizedModules"))
    : [];

  useEffect(() => {
    let check =
      orgInfo !== undefined ??
      orgInfo?.map((item) => {
        if (item?.moduleName == "donation") {
          return setIsDonationActive(item?.active);
        }
      });
    setIsDonationActive(
      orgInfo?.find((item) => item?.moduleName === "donation")?.active
    );
  }, []);

  useEffect(() => {
    setSortData((prev) => ({
      ...prev,
      ...(accountIdParam
        ? {
            filter: {
              ...prev.filter,
              accountId: accountIdParam,
            },
          }
        : {
            filter: {},
          }),
    }));
    setPage(0);
  }, [accountIdParam]);

  const handleOpenFilters = () => setOpenFilters((prev) => !prev);
  const closeFilter = () => setOpenFilters(false);

  const checkFilterApplied = useCallback(() => {
    let isFilterApplied = false;
    isFilterApplied = Object.keys(formik.values?.filterValues).some((key) => {
      if (typeof formik.values.filterValues[key] === "object") {
        return Object.keys(formik.values?.filterValues?.[key] || {})?.some(
          (subKey) => {
            return formik.values?.filterValues?.[key]?.[subKey];
          }
        );
      }
      return formik.values.filterValues[key];
    });

    if (formik.values?.ledgers?.length) {
      isFilterApplied = true;
    }

    return isFilterApplied;
  }, [formik.values.filterValues, formik.values.ledgers]);

  const isFilterApplied = checkFilterApplied();

  const clearFilter = () => {
    if (!isFilterApplied) return;
    formik.setValues({
      ...formik.values,
      filterValues: {
        dateRange: null,
        status: "",
        type: "",
        amountRange: {
          min: "",
          max: "",
        },
      },
      ledgers: [],
      ledger: [],
      subLedger: [],
    });
    if (filterApplied) {
      setApplyFilter(true);
      setFilterApplied(false);
    }
    setCheck([]);
    setCheckAll(false);
  };

  const handleFilter = () => {
    if (!isFilterApplied) return;
    const minAmountValue = formik.values?.filterValues?.amountRange?.min;
    const maxAmountValue = formik.values?.filterValues?.amountRange?.max;
    if (
      minAmountValue !== "" &&
      maxAmountValue !== "" &&
      +minAmountValue > +maxAmountValue
    ) {
      return toastr.info(
        "validation",
        "Minimum amount should be less than maximum amount"
      );
    }
    setApplyFilter(true);
    setFilterApplied(true);
    setPage(0);
    setCheck([]);
    setCheckAll(false);
  };

  const openBulkTagging = () => setOpenBulkTaggingModal(true);
  const closeBulkTagging = () => setOpenBulkTaggingModal(false);

  const getFilterData = () => {
    const filterData = {};

    if (formik.values?.filterValues?.dateRange?.length) {
      filterData.dateRange = {
        start: formik.values?.filterValues?.dateRange[0],
        end: formik.values?.filterValues?.dateRange[1],
      };
    }
    if (formik.values?.filterValues?.status) {
      filterData.status = formik.values?.filterValues?.status;
    }
    if (formik.values?.filterValues?.type) {
      filterData.type = formik.values?.filterValues?.type;
    }
    if (
      formik.values?.filterValues?.amountRange?.min ||
      formik.values?.filterValues?.amountRange?.max
    ) {
      filterData.amountRange = {
        start:
          formik.values?.filterValues?.amountRange?.min !== ""
            ? formik.values?.filterValues?.amountRange?.min
            : undefined,
        end:
          formik.values?.filterValues?.amountRange?.max !== ""
            ? formik.values?.filterValues?.amountRange?.max
            : undefined,
      };
    }
    if (formik.values?.ledger?.length) {
      filterData.ledger = formik.values?.ledger;
    }
    if (formik.values?.subLedger?.length) {
      filterData.subLedger = formik.values?.subLedger;
    }
    return filterData;
  };

  const addTagHandler = async (tags) => {
    setAddBulkTaggingLoading(true);
    const applyFilterData = filterApplied ? getFilterData() : {};
    const token = await getAccessTokenSilently();

    await DonationService.addBulkTagging(token, {
      filter: {
        ...sortData?.filter,
        ...applyFilterData,
        transactionIds: checkAll ? ["all"] : getIdsSelected(check),
      },
      search: searchValue || undefined,
      tags,
    })
      .then((res) => {
        toastr.success("Success", "Tags added successfully");
        closeBulkTagging();
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setAddBulkTaggingLoading(false);
      });
  };

  const handlePrintDonation = async () => {
    setDownloadLoader(true);
    const applyFilterData = filterApplied ? getFilterData() : {};
    const token = await getAccessTokenSilently();

    try {
      const res = await DonationService.addBulkDownload(token, {
        transactionIds: checkAll ? ["all"] : getIdsSelected(check),
        filter: {
          ...sortData?.filter,
          ...applyFilterData,
        },
        search: searchValue || undefined,
      });

      downloadBlobFile({
        data: res?.data,
        fileNamePrefix: "Donation letters",
        extension: "pdf",
      });
    } catch (err) {
      toastr.error("Error", err?.data?.message || "Something went wrong");
    } finally {
      setDownloadLoader(false);
    }
  };

  const handleRowClick = async (row) => {
    setOpenModal(true);
    setDrawerLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const res = await FinanceService.getTransactionById(token, row?._id);
      const tx = res?.result ?? res;
      const charge = tx?.Charges?.[0] ?? tx?.charge ?? {};
      setDonationModal({ ...tx, charge, charge_type: "donation", transactionId: tx?._id });
    } catch (err) {
      setDonationModal(row);
    } finally {
      setDrawerLoading(false);
    }
  };

  const viewLetterHandler = (data) => {
    setOpenDocumentModal(true);
    setViewDocumentContent(data);
  };

  return isDonationActive == false ? (
    <NotAuthorized title={"Donation"} />
  ) : (
    <div className="members pr-3 pr-sm-12 pt-10">
      <div className="d-flex justify-content-between align-items-center mb-8">
        <SubHeader
          className="subheader"
          {...{
            title: "Tribute letters",
            color: "#2455EF",
          }}
        />
      </div>
      <hr />

      <div className="mb-5">
        <div className="d-flex align-items-center yahrzeits__filter__bar justify-content-between">
          <SearchDownShift
            items={[]}
            name={searchValue}
            setName={setSearchValue}
            placeHolder="Search"
            autoFocus
          />
          <Button variant="filter" onClick={handleOpenFilters}>
            {filterApplied ? <FilterActive /> : <FilterIcon />}
            <span>Filter</span>
          </Button>
        </div>
        {openFilters && (
          <FilterWrapper>
            <DonationFilter
              closeFilter={closeFilter}
              openFilters={openFilters}
              handleOpenFilters={handleOpenFilters}
              formik={formik}
              clearFilter={clearFilter}
              handleFilter={handleFilter}
              isFilterApplied={isFilterApplied}
            />
          </FilterWrapper>
        )}
      </div>
      <div className="charges-table">
        <TributeLetterTable
          setEditTribute={setEditTribute}
          setViewClick={setViewClick}
          setEditTributeData={setEditTributeData}
          filters={sortData}
          sortCharged={sortCharged}
          formik={formik}
          viewClick={viewClick}
          page={page}
          setPage={setPage}
          applyFilter={applyFilter}
          setApplyFilter={setApplyFilter}
          searchValue={searchValue}
          filterApplied={filterApplied}
          openBulkTagging={openBulkTagging}
          setFilterApplied={setFilterApplied}
          handleRowClick={handleRowClick}
          check={check}
          setCheck={setCheck}
          checkAll={checkAll}
          setCheckAll={setCheckAll}
          handlePrintDonation={handlePrintDonation}
          downloadLoader={downloadLoader}
        />
      </div>

      <MyModal
        className={"add-notify__modal"}
        open={openBulkTaggingModal}
        onClose={closeBulkTagging}
      >
        <BulkTaggingModal
          closeModal={closeBulkTagging}
          addTagHandler={addTagHandler}
          addTagLoading={addBulkTaggingLoading}
        />
      </MyModal>

      <RightDrawer open={openModal} onClose={() => setOpenModal(false)}>
        {drawerLoading ? (
          <div style={{ width: "380px", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Spinner />
          </div>
        ) : (
        <FinanceDrawer
          data={{
            ...donationModal,
            charge_type: "donation",
          }}
          hideChargeInfo={true}
          hideDelete={true}
          hidePayNow={true}
          handleClose={() => setOpenModal(false)}
          onDeleted={() => {
            setOpenModal(false);
            window.dispatchEvent(new CustomEvent("save-transaction"));
          }}
          viewLetterHandler={viewLetterHandler}
          onReversalClick={async (payload) => {
            const token = await getAccessTokenSilently();
            await FinanceService.reverseCharge(payload, token)
              .then(() => toastr.success("Success", "Charge has been reversed"))
              .catch((error) =>
                toastr.error(error?.data?.message || "Something went wrong")
              );
          }}
          viewDocumentHandler={(documentId) => {
            setViewDocumentId(documentId);
            setOpenDocumentModal(true);
          }}
          downloadFileHandler={async (row) => {
            const { _id, name, type } = row;
            const token = await getAccessTokenSilently();
            await FinanceService.downloadDocument(token, _id).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              const currentDate = formatDate({ date: new Date(), formatType: "defaultWithUTC" });
              const fileType =
                type === "tax_statement"
                  ? "Statement"
                  : type.charAt(0).toUpperCase() + type.slice(1);
              const fileName = `${fileType}_${name.replaceAll(" ", "_")}_${currentDate}`;
              link.setAttribute("download", `${fileName}.pdf`);
              document.body.appendChild(link);
              link.click();
              window.URL.revokeObjectURL(url);
            });
          }}
          documentHandler={(row) => {
            setOpenShareModal(true);
            setDocumentRow(row);
          }}
        />
        )}
      </RightDrawer>

      <MyModal open={openNewCharge} className="new-charge-modal" onClose={() => { setOpenNewCharge(false); setNewChargeData(null); setHFinish(false); }}>
        <UserContext.Provider value={{ hfinish, setHFinish }}>
          {newChargeData && (
            <NewCharge
              handleClose={() => { setOpenNewCharge(false); setNewChargeData(null); setHFinish(false); }}
              data={newChargeData}
              activeIndex={1}
            />
          )}
        </UserContext.Provider>
      </MyModal>

      {openDocumentModal && (
        <Dialog
          open={openDocumentModal}
          onClose={() => {
            setOpenDocumentModal(false);
            setViewDocumentContent(null);
            setViewDocumentId(null);
          }}
          PaperProps={{
            style: {
              width: "888px",
              height: "90vh",
              overflow: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <ViewDocumentModal
            documentHtmlContent={viewDocumentContent}
            documentId={viewDocumentId}
            closeModal={() => {
              setViewDocumentContent(null);
              setViewDocumentId(null);
              setOpenDocumentModal(false);
            }}
          />
        </Dialog>
      )}

      <Dialog
        open={openShareModal}
        onClose={() => setOpenShareModal(false)}
        PaperProps={{
          style: {
            width: "888px",
            height: "637px",
            overflowX: "hidden",
            borderRadius: "22px",
          },
        }}
        fullWidth
        maxWidth={"md"}
      >
        <ShareDocumentsModal
          closeModal={() => setOpenShareModal(false)}
          documentsIds={[documentRow?._id]}
          documentType={documentRow?.type}
          defaultEmail={documentRow?.account_details?.defaultEmails || []}
          type="Document"
        />
      </Dialog>
    </div>
  );
};

export default Donation;
